import React from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { FooterButtons } from '@mobi/betslip/Components/Common/BetCard'
import { openShareOutgoing } from '@core/Areas/ShareBet/ShareBetOutgoing/helpers/emitter'

export const ShareButton: React.FC<{ historyCoupon: KambiHistoryCoupon }> = ({ historyCoupon }) => {
  const handleShareClick = () => {
    openShareOutgoing({ contextType: 'kambi', share: { coupon: historyCoupon } })
  }
  return <FooterButtons.ShareButton onClick={handleShareClick} data-testid='ShareButton' />
}
